import { IRequestEquipment, IRequestDeviceAntenna } from '../types/equipment.type'
import { IHopset } from '../types/spectrum-manager.type'
import { get_sfaf_data } from './sfaf-data-builder'
import { IAgencyOverride } from '../../shared/types/api/user.type'
import { IRequestFrequencyExclusion } from '../types/exercise.type'
import { ISFAFContents, ISFAFFrequency, SFAFStationClassType, SFAFObject } from '../types/sfaf.type'
import { createBlankSfaf, get_sfaf_string } from './sfaf-helpers'

export const generateSFAF = async (
  sfafFrequencies: ISFAFFrequency[],
  sfafContents: ISFAFContents[],
  sfafExcludedFrequencies: IRequestFrequencyExclusion[],
  sfafEquipments: IRequestEquipment[],
  hopsets: IHopset[],
  sfafEquipmentStationClasses: SFAFStationClassType[],
  sfafAntennas: Array<IRequestDeviceAntenna & { code: string }>,
  agencyOverride?: IAgencyOverride | null,
) => {
  const sfaf_obj_template = createBlankSfaf()
  let all_sfafs = ''

  try {
    for (let i = 0; i < sfafFrequencies.length; i++) {
      if (sfafFrequencies[i].saturn) {
        // TODO: What was this block responsible for?
        // query_get_hopset.trigger({
        //   additionalScope: {
        //     hopset_group: sfafFrequencies[i].hopset,
        //   },
        // })
        if (sfafFrequencies[i].saturn && hopsets.length) {
          for (let j = 0; j < hopsets.length; j++) {
            let sfaf_object: SFAFObject = JSON.parse(JSON.stringify(sfaf_obj_template))
            get_sfaf_data(
              sfaf_object,
              sfafFrequencies[i],
              sfafContents,
              sfafExcludedFrequencies,
              sfafEquipments,
              sfafEquipmentStationClasses,
              sfafAntennas,
              hopsets[j],
              agencyOverride,
            )

            let sfaf_string = get_sfaf_string(sfaf_object)
            all_sfafs += sfaf_string
          }
        }
      } else {
        let sfaf_object = JSON.parse(JSON.stringify(sfaf_obj_template))
        get_sfaf_data(
          sfaf_object,
          sfafFrequencies[i],
          sfafContents,
          sfafExcludedFrequencies,
          sfafEquipments,
          sfafEquipmentStationClasses,
          sfafAntennas,
          null,
          agencyOverride,
        )
        let sfaf_string = get_sfaf_string(sfaf_object)
        all_sfafs += sfaf_string
      }
    }
    if (sfafFrequencies.length === 0) {
      all_sfafs = 'Insufficient data. You need at least one location and one frequency, connected.'
    }
  } catch (error) {
    all_sfafs = 'Error building SFAF' + error
    console.log(error)
  } finally {
    return all_sfafs
  }
}
